/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const addressDataSchema = z.object({
	line1: z.string().nullable(),
	line2: z.string().nullable(),
	city: z.string().nullable(),
	state: z.string().nullable(),
	postalCode: z.string().nullable(),
	country: z.string().nullable(),
})

export type AddressDataSchema = z.infer<typeof addressDataSchema>
